export default "__VITE_ASSET__Bt7BXYeo__"